import * as React from "react";
import { Button, Skeleton, Stack } from "@mui/material";
import ViewListIcon from "@mui/icons-material/ViewList";
import LineAxisIcon from "@mui/icons-material/LineAxis";
import { useNavigate } from "react-router-dom";

const IndexesOptInPlaceholder = ({ isTeams, teamId, loading }) => {
    const navigate = useNavigate();
    const redirectToIndexesSettings = () => {
        if (isTeams) return navigate(`/teams/${teamId}/indexes-settings`);
        return navigate("/indexes-settings");
    };
    if (loading)
        return (
            <Stack alignItems="center" style={{ width: "100%" }}>
                <Skeleton variant="rounded" width="100%" height={160} />
            </Stack>
        );
    return (
        <Stack alignItems="center" spacing={2} style={{ width: "100%" }}>
            <LineAxisIcon fontSize="large" />
            <p style={{ margin: 0 }}>Seems like you have not activated the indexes section.</p>
            <p style={{ margin: 0, fontSize: "12px" }}>
                You can opt-in and configure indexes by clicking the button bellow.
            </p>
            <Button
                startIcon={<ViewListIcon />}
                onClick={() => {
                    redirectToIndexesSettings();
                }}
                style={{ width: "257px", fontSize: "12px" }}
            >
                {isTeams ? "Configure Team Indexes" : "Configure Indexes"}
            </Button>
        </Stack>
    );
};

export default IndexesOptInPlaceholder;
